import { createSlice } from '@reduxjs/toolkit';
import {
  createTax,
  fetchAllTaxes,
  fetchTaxById,
  updateTax,
  deleteTax
} from './taxActions';
import { TaxState } from './taxTypes';

const initialState: TaxState = {
  taxes: [],
  selectedTax: undefined,
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    update: false,
    delete: false,
  },
  errors: {}
};

const taxSlice = createSlice({
  name: 'taxes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createTax.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createTax.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.taxes.push(action.payload.data);
      })
      .addCase(createTax.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllTaxes.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllTaxes.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.taxes = action.payload.data;
      })
      .addCase(fetchAllTaxes.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchTaxById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchTaxById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedTax = action.payload.data;
      })
      .addCase(fetchTaxById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updateTax.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateTax.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.taxes.findIndex(t => t.tax_id === action.payload.id);
        if (index !== -1) {
          state.taxes[index] = { ...action.payload.data, tax_id: action.payload.id };
        }
      })
      .addCase(updateTax.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      // Delete
      .addCase(deleteTax.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deleteTax.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.taxes = state.taxes.filter(t => t.tax_id !== action.payload);
      })
      .addCase(deleteTax.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      });
  }
});

export default taxSlice.reducer;
